export default __webpack_public_path__ + "static/media/gmail.8f5f8028.svg";